import React, { useEffect } from 'react';

import { ConsentBanner, initializeControls } from '@atlassian/browser-storage-controls';

const JSMCookieConsentBanner = () => {
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        initializeControls({ product: 'jira' });
    }, []);

    return <ConsentBanner product="jira" />;
};

export default JSMCookieConsentBanner;
